import { BsSearch } from "react-icons/bs";
import { SearchBar, SearchBarContainer } from "./User.style";
export const GlobalFilter = ({
  half,
  searchValue,
  setSearchValue,
  disabled,
  placeholder = "Search",
  containerClassName,
  searchBarClassName,
}: any) => {
  return (
    <SearchBarContainer half={half} className={containerClassName}>
      <BsSearch size={18} color="gray" />
      <SearchBar
        className={searchBarClassName}
        data-testid="search-bar"
        type="search"
        placeholder={placeholder}
        value={searchValue || ""}
        disabled={disabled}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
      />
    </SearchBarContainer>
  );
};
// "border border-solid border-gray-300 lg:w-80 xl:w-60 xl:max-w-52"
// className="lg:w-80 xl:w-60 xl:max-w-52"
